var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9864 12.4863L16.9864 12.4864L9.48642 19.9864C9.42254 20.0502 9.34671 20.1009 9.26324 20.1355C9.17978 20.1701 9.09033 20.1878 8.99999 20.1878C8.90965 20.1878 8.8202 20.1701 8.73674 20.1355C8.65327 20.1009 8.57744 20.0502 8.51356 19.9864C8.44968 19.9225 8.39901 19.8466 8.36444 19.7632C8.32987 19.6797 8.31207 19.5903 8.31207 19.4999C8.31207 19.4096 8.32987 19.3201 8.36444 19.2367C8.39901 19.1532 8.44968 19.0774 8.51356 19.0135L15.4839 12.0441L15.5281 11.9999L15.4839 11.9557L8.51356 4.98636C8.51356 4.98636 8.51356 4.98636 8.51356 4.98636C8.38455 4.85735 8.31207 4.68237 8.31207 4.49993C8.31207 4.31748 8.38455 4.14251 8.51356 4.0135C8.64257 3.88449 8.81754 3.81201 8.99999 3.81201C9.18244 3.81201 9.35741 3.88449 9.48642 4.0135L16.9864 11.5135L16.9864 11.5135C17.0504 11.5774 17.1011 11.6532 17.1357 11.7367C17.1703 11.8201 17.1881 11.9096 17.1881 11.9999C17.1881 12.0903 17.1703 12.1797 17.1357 12.2632C17.1011 12.3467 17.0504 12.4225 16.9864 12.4863Z",
    strokeWidth: 0.125
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.7e8705fe5e297784f2d83ef4c908cb52.svg";
export { ForwardRef as ReactComponent };